<template>
  <div class="section-container">
    <h1 class="wow slideInLeft" v-html="productHeader.title[getIndex()]"></h1>
    <div class="wow fadeIn section-header-underline"></div>
    <p class="wow fadeInUp">{{ productHeader.discription[getIndex()] }}</p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "productHeader",
  computed: mapGetters(["productHeader"]),
  methods: {
    getIndex() {
      if (this.$i18n.locale === "ku") return 0;
      else if (this.$i18n.locale === "ar") return 1;
      else return 2;
    }
  }
};
</script>
